/*@flow*/

export const darkBlue = "#1f5486"; // dark blue
export const lightWhite = "#6394c4"; // light white

export const ltButtonBarBg = "#F8F8F8"; // light button bar background
export const ltButtonBarColor = "#3381CD"; // border color
export const ltDrawerLeftBorder = "#3381CD"; // border color
export const textColor = "#333"; // text color
export const inputsColor = "#909090";
